import request from '../utils/request';

/**
 * 获取聊天会话分页列表
 * @param {Object} params 查询参数
 * @returns {Promise} 请求结果
 */
export function getChatSessionList(params) {
  return request({
    url: '/chat-sessions/list',
    method: 'get',
    params
  });
}

/**
 * 获取会话成员分页列表
 * @param {number} sessionId 会话ID
 * @param {Object} params 查询参数
 * @returns {Promise} 请求结果
 */
export function getSessionMemberList(sessionId, params) {
  return request({
    url: `/chat-sessions/${sessionId}/members`,
    method: 'get',
    params
  });
}

/**
 * 删除聊天会话
 * @param {number} id 会话ID
 * @returns {Promise} 请求结果
 */
export function deleteChatSession(id) {
  return request({
    url: `/chat-sessions/${id}`,
    method: 'delete'
  });
}

/**
 * 获取聊天消息分页列表
 * @param {Object} params 查询参数
 * @returns {Promise} 请求结果
 */
export function getChatMessageList(params) {

  return request({
    url: '/chat-messages/list',
    method: 'get',
    params
  });
}

/**
 * 删除聊天消息
 * @param {number} id 消息ID
 * @returns {Promise} 请求结果
 */
export function deleteChatMessage(id) {
  return request({
    url: `/chat-messages/${id}`,
    method: 'delete'
  });
} 